import { createWebSocketConnection } from "@/webSocketFactory";

import { nextCargoApi } from "../../baseApi";
import { AttendanceCountUpdated, Called } from "./socket.types";

export const socketTvApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    driverCalled: build.query<Called, void>({
      queryFn: () => ({ data: { driverCalled: null, type: null, content: null } }),
      onCacheEntryAdded: async (_, { cacheDataLoaded, updateCachedData, cacheEntryRemoved }) => {
        const socket = createWebSocketConnection();

        await cacheDataLoaded;

        socket.on("checkInCallResponse", (data: Called) => {
          console.log("📡 Dados recebidos do socket:", data);
          updateCachedData((draft) => {
            Object.assign(draft, data);
          });
        });

        socket.connect();
        await cacheEntryRemoved;
        socket.disconnect();
      }
    }),
    attendanceCountUpdated: build.query<AttendanceCountUpdated, void>({
      queryFn: () => ({ data: { type: null, content: null, inAttendance: 0 } }),
      onCacheEntryAdded: async (_, { cacheDataLoaded, updateCachedData, cacheEntryRemoved }) => {
        const socket = createWebSocketConnection();

        await cacheDataLoaded;

        socket.on("countInAttendanceResponse", (data: AttendanceCountUpdated) => {
          console.log("📡 Dados recebidos do socket:", data);
          updateCachedData((draft) => {
            Object.assign(draft, data);
          });
        });

        socket.connect();
        await cacheEntryRemoved;
        socket.disconnect();
      }
    })
  })
});

socketTvApi.enhanceEndpoints({
  endpoints: {
    driverCalled: {
      providesTags: ["DriverCalled"]
    },
    attendanceCountUpdated: {
      providesTags: ["AttendanceCountUpdated"]
    }
  }
});
